/* eslint-disable no-console */
/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import { Box, Skeleton, Text } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { ContentState } from 'draft-js';
import DOMPurify from 'dompurify';
import { ApplicationState } from '~/store/store';
import { ProposalSectionProps } from '~/store/ducks/Proposal/types';
import ProposalService from '~/store/ducks/Proposal/services';
import { toastError } from '~/helpers/toast';
import markdownConverter from '~/helpers/markdownConverter';

const TermsConditions: React.FC<ProposalSectionProps> = ({ isExpanded }) => {
  const { id: projectId } = useSelector((state: ApplicationState) => state.project);
  const { data: proposalData } = useSelector((state: ApplicationState) => state.proposal);
  const [loading, setLoading] = useState<boolean>(false);
  const [termsConditions, setTermsConditions] = useState(null);

  const fetchTermsConditions = async () => {
    try {
      setLoading(true);
      const response = await ProposalService.getTermsConditions(projectId, proposalData.id);
      setTermsConditions(response.data.text);
    } catch (err) {
      console.error(err);
      toastError('proposal', 'Erro ao recuperar Termos e Condições.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isExpanded) {
      fetchTermsConditions();
    }
    return () => setTermsConditions(null);
  }, [isExpanded]);

  return (
    <Skeleton isLoaded={!loading}>
      <Box className="proposal__section">
        <div
          className="proposal__text"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(markdownConverter(termsConditions)),
          }}
        />
      </Box>
    </Skeleton>
  );
};

export default TermsConditions;
